<template>
  <div id="userManual" v-click-outside="hide">
    <div @click="show = true">
      <img src="../../assets/img/UserManual.png" />
    </div>
    <div :class="['dropdownUser', { show: show }]" @mouseleave="show = false">
      <div class="box">
        <div class="list" v-for="(option, index) in optionList" :key="index">
          <a v-if="option.link" :href="option.link" target="_blank">
            <div :class="['option']"><i :class="option.icon"></i>{{ $t(option.name) }}</div>
          </a>
          <div v-else @click="option.action">
            <div :class="['option']"><i :class="option.icon"></i>{{ $t(option.name) }}</div>
          </div>
        </div>
      </div>
    </div>
    <ModalNewUserGuide v-if="showModalNewUserGuide" :showModal.sync="showModalNewUserGuide" />
  </div>
</template>

<script lang="ts">
import ModalNewUserGuide from "@/components/header/ModalNewUserGuide.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: { ModalNewUserGuide },
})
export default class extends Vue {
  private show = false;
  private showModalNewUserGuide = false;
  private optionList = [
    {
      name: "SuggestionForNewUsers",
      icon: "far fa-map",
      link: "",
      action: () => this.showModal(),
    },
    {
      name: "ManualPayroll",
      icon: "far fa-file-alt",
      link: "https://www.peakaccount.com/peak-manual/peak-payroll",
    },
    {
      name: "VideoUserManual",
      icon: "fas fa-play",
      link: "https://www.youtube.com/watch?v=BEkzw5wx3LI&list=PLKx_LgGwE9YMT3LhpKID8Y1OTVy4wBjM9&index=2",
    },
  ];

  public hide() {
    this.show = false;
  }

  public showModal() {
    this.showModalNewUserGuide = true;
  }
}
</script>

<style lang="scss" scoped>
#userManual {
  img {
    width: 18px;
    margin-top: -9px;
    margin-left: 10px;
    cursor: pointer;
  }
  .dropdownUser {
    position: absolute;
    top: 63px;
    margin-left: -161px;
    width: max-content;
    border-radius: 6px;
    overflow: hidden;
    background: rgb(255, 255, 255);
    z-index: 99;
    max-height: 0px;
    @include shadowboxLv2;
    transition: 0.5s;
    .name {
      text-align: center;
      padding: 15px;
      cursor: pointer;
      transition: all 0.5s ease;
      &:hover {
        color: $purple_default;
      }
    }
    hr {
      margin-top: 0px;
      width: 80%;
    }
    a {
      color: unset;
    }
    .list {
      position: relative;
    }
    .option {
      position: relative;
      display: flex;
      align-items: center;
      padding: 10px 20px 10px 10px;
      cursor: pointer;
      transition: all 0.5s ease;

      i {
        font-size: 14px;
        width: 30px;
        text-align: center;
      }
      &:hover {
        color: $green_active;
        background: $hover;
      }
    }
  }
  .show {
    max-height: 500px;
  }
}
</style>
